<template>
  <div :class="{ 'topbar-notifications': true, 'is-inactive': !unreadNotificationsCount }">
    <span
      class="topbar-notifications-icon"
      @click.stop="toggleNotifications()">
      <icon
        name="ring-bell"
        customWidth="15"
        customHeight="18"
        :primaryColor="unreadNotificationsCount ? 'color-light' : 'color-dark'" />
      <span
        v-if="unreadNotificationsCount"
        class="topbar-notifications-badge">
        <template v-if="unreadNotificationsCount <= 99">
          {{ unreadNotificationsCount }}
        </template>
        <template v-else>
          99+
        </template>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'topbar-notifications',
  computed: {
    unreadNotificationsCount () {
      return this.$store.state.global.notifications.filter(n => !n.readed_at).length;
    }
  },
  methods: {
    toggleNotifications () {
      this.$bus.$emit('toggle-app-notifications');
      this.$bus.$emit('hide-topbar-user-dropdown');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.topbar-notifications {
  position: relative;

  &.is-inactive {
    .topbar-notifications-icon {
      background: $color-button-primary-light;
    }
  }

  &-icon {
    align-items: center;
    background: $color-button-primary-light;
    border-radius: $border-radius-small;
    cursor: pointer;
    display: flex;
    height: 3.6rem;
    justify-content: center;
    margin-left: 1.2rem;
    width: 3.6rem;
  }

  &-badge {
    align-items: center;
    background: $color-badge;
    border-radius: 50%;
    color: $color-light;
    display: flex;
    font-size: 1.2rem;
    font-weight: bold;
    height: 2rem;
    justify-content: center;
    line-height: 1;
    position: absolute;
    top: -.75rem;
    right: -.75rem;
    width: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/TopBarNotifications.vue